import registerPushToken from "./register-push-token-route";
import unregisterPushToken from "./unregister-push-token-route";

export default {
  "register-push-token": registerPushToken,
  "unregister-push-token": unregisterPushToken,
};
